module.exports = __webpack_public_path__ + "5bdb544aa9987f2c7c70748f50bdd140.pdf";